import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

export default (function () {
    return {
        restrict: 'A',
        scope: {
            category: '@'
        },
        transclude: true,
        link: function link(scope, element, attrs, ctrl, transcludeFn) {
            var enabled = ApplicationFeatures.hasFeature(scope.category);
            if (enabled) {
                var content = transcludeFn();
                element.append(content);
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-featuredetection-angular/directives/FeatureToggler.js
// module id = 1348
// module chunks = 0